import React, { createContext, useState, useContext, useEffect } from 'react';

const ServerContext = createContext();

export const ServerProvider = ({ children }) => {
  const [serverError, setServerError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  // Funzione per gestire l'errore del server
  const handleServerError = (error) => {
    setServerError(true);
    setErrorMessage(error.message || 'Errore di connessione al server. Riprova più tardi.');
  };

  // Funzione per resettare l'errore
  const resetServerError = () => {
    setServerError(false);
    setErrorMessage('');
  };

  // Ascolta gli eventi personalizzati per gli errori di server
  useEffect(() => {
    const handleServerDown = (event) => {
      handleServerError(event.detail || {});
    };

    window.addEventListener('serverConnectionError', handleServerDown);

    return () => {
      window.removeEventListener('serverConnectionError', handleServerDown);
    };
  }, []);

  // Chiusura dell'applicazione
  const exitApplication = () => {
    // Rimuovi tutti i dati di sessione
    localStorage.clear();
    sessionStorage.clear();
    
    // Reindirizza alla pagina di login
    window.location.href = '/login';
  };

  const value = {
    serverError,
    errorMessage,
    handleServerError,
    resetServerError,
    exitApplication
  };

  return (
    <ServerContext.Provider value={value}>
      {children}
    </ServerContext.Provider>
  );
};

export const useServer = () => useContext(ServerContext);

export default ServerContext;